exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userrelation-component{padding:15px 0}.userrelation-component .tabs{border:none}.userrelation-component .tabs .tabs-title{float:none;display:inline-block}.userrelation-component .tabs .tabs-title a{border:1px solid #41464b;padding:8px 25px;font-size:14px;color:#41464b;background:transparent;border-radius:0 10px 10px 0}.userrelation-component .tabs .tabs-title:first-child a{border-radius:10px 0 0 10px}.userrelation-component .tabs .tabs-title.is-active a{color:#fff;background-color:#41464b}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/UserRelation.scss
// module id = 676
// module chunks = 0